import Vue from "vue/dist/vue.esm.js";
import VueRouter from "vue-router";
import Oauth from "@/core/Models/Oauth";
import qs from "qs";
import { routes } from "@/router/routes";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  base: "",
  parseQuery(query) {
    return qs.parse(query, {
      decoder: (str) => {
        return decodeURIComponent(str);
      },
    });
  },
  stringifyQuery: (query) => {
    const result = qs.stringify(query, {
      encoder: (str) => {
        return encodeURIComponent(str);
      },
    });
    return result ? `?${result}` : "";
  },
  routes,
});

router.beforeEach((to, from, next) => {
  // catch 404 and send to back 404.html
  if (to.name === "NotFound") return location.replace("/404");

  // catching redundant navigation to same path route
  const lastPath = from.fullPath;
  const goPath = to.fullPath;
  if (lastPath === goPath) return;
  // catching guarded route
  if (to.matched.some((record) => record.meta.authenticationRequired)) {
    const userConnected = JSON.parse(localStorage.getItem("user-connected"));
    if (!Oauth.localStorage) {
      return next({
        name:
          to.name === "WalletCourse" || to.name === "WalletSafe"
            ? "Register"
            : "Login",
        query: { next: `${to.fullPath}` },
      });
    }
    // checking permissions
    if (
      to.matched.some(
        (record) =>
          record.meta.rolesRequired &&
          userConnected &&
          !record.meta.rolesRequired.some(
            (role) => role === userConnected.roles[0].function
          )
      )
    ) {
      return next({
        name: "ORGANIZATION_DASHBOARD",
        params: {
          organizationId: userConnected.roles[0].organization,
        },
      });
    }
    next();
  } else next();
});
